  <!-- Start Blog Area -->
  <div class="bk-blog-area section-ptb-120 clearfix" style="background-color: #491d6b;">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title--between wow move-up">
                    <div class="title">
                        <h3> Sigue nuestro canal en<span class="theme-creative"> Youtube </span></h3>
                    </div>
                    <!-- link 
                    <div class="section-btn mt_mobile--30">
                        <a class="button-text" href="#"><span>View all posts</span><i class="fa fa-arrow-right"></i></a>
                    </div>
                     -->
                </div>
            </div>
        </div>

        <div class="row mt--40">

              <!-- Video 1 -->
            <div class="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 wow move-up mt--30">
                <div class="blog blog-style--2 creative--blog">
                    <div class="thumb">
                        <a href="blog-details.html"><img src="assets/img/ninos/video-1.jpg" alt="Activador Akashico® Luz Ilimitada ® Niños, Facilitador"></a>
                        <div class="video-btn">
                            <a class="video-icon play__btn" href="https://www.youtube.com/watch?v=GuGA4qW5USo"></a>
                        </div>
                    </div>
                    <div class="blog-content">
                        <div class="content">
                            <h3 class="the-title"><a>Activador Akashico® Luz Ilimitada ® Niños, Facilitador</a></h3>
                            <ul class="meta">
                                <li>Formación para niños</li>
                                <li><a href="https://www.youtube.com/channel/UCovkoYjnKsw2IDko4G9876w" target="_blank">Ir al canal</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            

            <!-- Video 2 -->
            <div class="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 wow move-up mt--30">
                <div class="blog blog-style--2 creative--blog">
                    <div class="thumb">
                        <a href="blog-details.html"><img src="assets/img/ninos/video-2.jpg" alt="Activador Akashico® Corazón de Luz"></a>
                        <div class="video-btn">
                            <a class="video-icon play__btn" href="https://www.youtube.com/watch?v=y6_7E0TCWts"></a>
                        </div>
                    </div>
                    <div class="blog-content">
                        <div class="content">
                            <h3 class="the-title"><a>Activador Akashico® Corazón de Luz</a></h3>
                             <ul class="meta">
                                <li>Formación para niños</li>
                                <li><a href="https://www.youtube.com/channel/UCovkoYjnKsw2IDko4G9876w" target="_blank">Ir al canal</a></li>
                            </ul>
                           
                        </div>
                    </div>
                </div>
            </div>
            

              <!-- Video 3 -->
            <div class="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 wow move-up mt--30">
                <div class="blog blog-style--2 creative--blog">
                    <div class="thumb">
                        <a href="blog-details.html"><img src="assets/img/ninos/video-3.jpg" alt="Activador Akashico® Luz Ilimitada® Niños, Facilitador"></a>
                        <div class="video-btn">
                            <a class="video-icon play__btn" href="https://www.youtube.com/watch?v=-d8kfdgq7_8"></a>
                        </div>
                    </div>
                    <div class="blog-content">
                        <div class="content">
                            <h3 class="the-title"><a>Activador Akashico® Luz Ilimitada® Niños, Facilitador</a></h3>
                             <ul class="meta">
                                <li>Formación para niños</li>
                                <li><a href="https://www.youtube.com/channel/UCovkoYjnKsw2IDko4G9876w" target="_blank">Ir al canal</a></li>
                            </ul>
                            
                        </div>
                    </div>
                </div>
            </div>
           

          

        </div>

    </div>
</div>
<!-- End Blog Area -->

